import { Sine, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { AnimatedObstacle } from "../../GameObjects/Obstacles/AnimatedObstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class Scarab extends AnimatedObstacle {
    private static readonly SPEED: number = -75;
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, 200);

    private _hoverTween: TweenMax;

    constructor() {
        super(
            new HLF.SpriteAnimation(
                "scarab-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00", 4, 2,
                12, true,
            ),
            Scarab.SPEED,
            new BoxCollider(0, 100, -45, 45),
        );
        this.position.y = HLF.Random.floatBetweenPoint(Scarab.Y_RANGE);
        this._collisionSfx = SFX.IMPACT_SCARAB;

        this._hoverTween = TweenMax.to(this, 1.0, {
            y: this.position.y + 25,
            ease: Sine.easeInOut,
            repeat: -1,
            yoyo: true,
        });
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._hoverTween !== undefined) { this._hoverTween.kill(); }
        super.destroy(pOptions);
    }

    public onCollision(pIsBalloonInvuln: boolean): void {
        super.onCollision(pIsBalloonInvuln);
        if (pIsBalloonInvuln) {
            this.playDeflectAnim();
        }
    }
}
